/**
 * Hook customizado para atualização de perfil do usuário
 * Encapsula a lógica de atualização e gerenciamento de estado
 */

import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import useFetch from "./useFetch";
import { API_Q_USER } from "../constants/api";
import { updateUserProfile } from "../services/userService";
import { updateUser } from "../services/userService";
import { updateMyUser } from "../store/actions/_LocalSession";
import { setAnalyticsGetProfile } from "../helpers/analyticsHelpers";

/**
 * Hook para gerenciar atualização de perfil do usuário
 * @returns {Object} Objeto com funções e estados para atualização de perfil
 */
export const useProfileUpdate = () => {
  const { session } = useSelector((state) => state.session);
  const dispatch = useDispatch();

  const [, isLoading, error, fetchUser] = useFetch({
    url: API_Q_USER,
    autoInit: false,
  });

  /**
   * Atualiza o perfil do usuário
   * @param {string} newProfile - Novo tipo de perfil (professional, patient, personal)
   * @returns {Promise} Promise resolvida com a resposta ou rejeitada com erro
   */
  const updateProfile = useCallback(
    async (newProfile) => {
      try {
        const userData = session?.my_user || {};
        const payload = {profile: newProfile };
        const response = await updateUser(fetchUser, payload);
        dispatch(updateMyUser({profile: newProfile}));
        setAnalyticsGetProfile({ profile: newProfile });
        return response;
      } catch (err) {
        console.error("Erro ao atualizar perfil:", err);
        throw err;
      }
    },
    [fetchUser, session, dispatch]
  );

  return {
    updateProfile,
    isLoading,
    error,
    currentProfile: session?.my_user?.profile,
  };
};

export default useProfileUpdate;
